export const TODO_MODEL = "todo";

const todoModel = {
  complete: "",
  todoable_type: "",
  todoable_id: "",
  category: "",
  action: "",
  action_details: "",
  created_at: "",
  updated_at: "",
  icon: "",
  deadline_date: "",
  todoable: {},
  user: {
    jsonApi: "hasOne",
    type: "users"
  }
};

export default todoModel;
